import { createSettingsListSection } from "../../SettingsListSection";
import ProjectType from "../../../../../models/ProjectType";

export const projectTypeDataComponentId = "dataComponentProjectType";

export default createSettingsListSection({
  dataComponentId: projectTypeDataComponentId,
  model: ProjectType,
  apiRoute: "project-types",
  label: "Project Type",
  pluralLabel: "Project Types",
  createModal: "CreateProjectType",
  editModal: "EditProjectType",
  editModalEntityKey: "projectType",
  permissions: ["manage-project-types"],
});
